export class EmployeeDropdownResult {
    public id: number = 0;
    public fullName: string = '';
    public personalPictureFileName: string = '';
}
